/**
 * API Service para Badges de Usuario
 * Obtener badges obtenidos y progreso
 */

import axios from 'axios';
import { BASE_URL } from '../../settings';

/**
 * Obtener badges y progreso del usuario actual
 * KHAN-229: [API Standardization] endpoint migrado de Badges/progress/{uid}/
 * (verbo en el path) a users/{uid}/badge-progress/ (sub-recurso + metodo
 * HTTP GET). Shape de la respuesta sin cambios.
 * @param {number} userId - ID del usuario
 * @param {string} token - Token JWT
 */
export const getUserBadgesWithProgress = async (userId, token) => {
  try {
    const response = await axios.get(
      `${BASE_URL}users/${userId}/badge-progress/`,
      {
        headers: {
          'Authorization': token
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error al obtener badges del usuario:', error);
    throw error;
  }
};

/**
 * Obtener todos los badges del usuario (solo los obtenidos)
 * @param {number} userId - ID del usuario
 * @param {string} token - Token JWT
 */
export const getUserBadges = async (userId, token) => {
  try {
    // KHAN-242: UserBadge/?userid= -> user-badges/?user= (esa ruta vieja nunca
    // existio en el backend; esta funcion no tiene callers).
    const response = await axios.get(
      `${BASE_URL}user-badges/?user=${userId}`,
      {
        headers: {
          'Authorization': token
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error al obtener badges del usuario:', error);
    throw error;
  }
};
